import { Download } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import React, { Fragment, useEffect, useState } from "react";
import { PageHero } from "../components/Global/PageHero";
import { db } from "../firebase";
import { BackToTop } from "../templates/BackToTop";

export const Tracts = () => {
  const [tracts, setTracts] = useState([]);
  const [loading, setLoading] = useState(true);

  const getTracts = async () => {
    try {
      const q = query(
        collection(db, "sbc-tracts"),
        orderBy("createdAt", "desc"),
      );
      const snap = await getDocs(q);
      setTracts(
        snap.docs.map((d) => ({
          _id: d.id,
          ...d.data(),
          createdAt: d.data().createdAt?.toDate() || new Date(),
        })),
      );
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTracts();
  }, []);

  return (
    <Fragment>
      <PageHero
        eyebrow="Resources"
        title="SBC"
        highlight="Tracts"
        subtitle="Monthly Salvation Believers Class downloadable resources."
      />

      <div className="relative flex items-center justify-center py-10 overflow-hidden">
        <span className="absolute font-aref text-6xl md:text-9xl text-secondary opacity-10 select-none pointer-events-none uppercase tracking-widest">
          TRACT
        </span>
        <p className="relative font-abel text-lg md:text-2xl text-primary text-center z-10">
          Monthly SBC Resources
        </p>
      </div>

      <div className="px-4 md:px-10 lg:px-20 pb-16">
        {loading ? null : tracts.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 gap-4 text-center">
            <Download
              className="text-secondary opacity-40"
              style={{ fontSize: 64 }}
            />
            <p className="font-abel text-lg md:text-xl text-primary opacity-60">
              Resources coming soon. Check back next month.
            </p>
          </div>
        ) : (
          <Grid container spacing={4}>
            {tracts.map((tract) => (
              <Grid item xs={12} sm={6} md={4} key={tract._id}>
                <div
                  className="bg-white rounded-2xl transition-shadow duration-300 p-6 flex flex-col gap-3 h-full"
                  style={{
                    boxShadow:
                      "0 -4px 12px rgba(0,0,0,0.07), 0 4px 16px rgba(0,0,0,0.07)",
                    borderTop: "3px solid #ffc000",
                  }}
                >
                  <p className="font-aref text-secondary text-sm md:text-base font-semibold">
                    {(() => {
                      const d = tract.date || tract.createdAt;
                      if (!d) return "";
                      const date = d?.toDate ? d.toDate() : new Date(d);
                      return date.toLocaleDateString("en-GB", {
                        month: "long",
                        year: "numeric",
                      });
                    })()}
                  </p>
                  <p className="font-aref text-primary text-lg md:text-xl font-bold leading-tight">
                    {tract.title}
                  </p>
                  <a
                    href={tract.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 inline-flex items-center gap-2 bg-secondary text-white font-abel text-sm md:text-base px-4 py-2 rounded-lg hover:opacity-90 transition-opacity w-fit"
                  >
                    <Download fontSize="small" />
                    Download
                  </a>
                </div>
              </Grid>
            ))}
          </Grid>
        )}
      </div>

      <BackToTop />
    </Fragment>
  );
};
